module.exports = __webpack_public_path__ + "static/img/store-label-name.d678d16f.png";